import type { Ticket } from "./types";

export const DEMO_TICKETS: Ticket[] = [
  {
    id: "II8-DEMO1",
    name: "林小島",
    phone: "0912-345-678",
    email: "island@example.com",
    ticketType: "早鳥票（通票）：800",
    quantity: 2,
    sessions: ["afternoon", "evening"],
    afternoonPerformer: "LuvRush",
    eveningPerformer: "白晝U:ME",
    paymentMethod: "延用 7/11 票款，金額相同，無須補款",
    transferSuffix: "",
    paymentRecorded: true,
    units: [
      { id: "II8-DEMO1-1-A", seat: 1, session: "afternoon", performer: "LuvRush", checkedIn: false },
      { id: "II8-DEMO1-2-A", seat: 2, session: "afternoon", performer: "LuvRush", checkedIn: false },
      { id: "II8-DEMO1-1-E", seat: 1, session: "evening", performer: "白晝U:ME", checkedIn: false },
      { id: "II8-DEMO1-2-E", seat: 2, session: "evening", performer: "白晝U:ME", checkedIn: false },
    ],
    checkIns: {
      afternoon: { count: 0 },
      evening: { count: 0 },
    },
  },
  {
    id: "II8-DEMO2",
    name: "海風",
    phone: "0988-765-432",
    email: "sea@example.com",
    ticketType: "早鳥票（午場）：500",
    quantity: 1,
    sessions: ["afternoon"],
    afternoonPerformer: "Primulav",
    eveningPerformer: "（我買的是午場）",
    paymentMethod: "於演出前一日22:00前至杰克音樂櫃台付款",
    transferSuffix: "",
    paymentRecorded: false,
    units: [
      { id: "II8-DEMO2-1-A", seat: 1, session: "afternoon", performer: "Primulav", checkedIn: false },
    ],
    checkIns: {
      afternoon: { count: 0 },
      evening: { count: 0 },
    },
  },
];
